export default __webpack_public_path__ + "static/media/logo-kathok.5323dffe.png";